import { createStyles, Theme } from '@material-ui/core'

const InviteUserModalStyles = (theme: Theme) => createStyles({
  wrapper: {
    marginBottom: theme.spacing(1) * 3,
  },
  button: {

  },
  contentWrapper: {

  },
  radioWrapper: {
    margin: `${theme.spacing(1) * 1}px 0`,
    cursor: 'pointer',
  },
  radioPaper: {
    display: 'flex',
    height: '100px',
    alignItems: 'center',
  },
  radioRight: {
    marginLeft: `${theme.spacing(1) * 0.5}px`,
  },
  alertText: {
    color: '#00000099',
  },
  emailIcon: {
    opacity: '0.5',
  },
})

export default InviteUserModalStyles
